import { render, staticRenderFns } from "./VDraggableList.vue?vue&type=template&id=7c8039ad&scoped=true&"
import script from "./VDraggableList.vue?vue&type=script&lang=ts&"
export * from "./VDraggableList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c8039ad",
  null
  
)

export default component.exports